import React, {Component} from 'react'
import Geosuggest from 'react-geosuggest'
import {FormField} from '@cred/react-form-field'
import {Label} from '@cred/react-label'

class GeosuggestComponent extends Component {
  static displayName = 'GeosuggestComponent'
  componentDidMount() {
    const {autoFocus, autoFocusDelay, triggerSuggestSelect = () => {}} = this.props

    triggerSuggestSelect(() => this.geoSuggest.selectSuggest())

    if (autoFocus) {
      setTimeout(() => {
        this.geoSuggest.focus()
      }, autoFocusDelay)
    }
  }
  render() {
    const {
      input,
      label,
      meta,
      placeholder,
      handleSelect,
      autoComplete,
      getSuggestLabel,
      renderSuggestItem,
      skipSuggest,
      onKeyDown,
      onPaste,
      warning,
      suggestOnKeyPress = () => {},
      handleSuggestNoResult = () => {},
    } = this.props

    return (
      <FormField status={meta} label={label} error={meta.error} value={input.value} warning={warning}>
        <Geosuggest
          ref={el => this.geoSuggest = el}
          inputClassName="InspectletIgnore"
          autoComplete={autoComplete}
          onSuggestSelect={handleSelect}
          placeholder={placeholder}
          country="us"
          autoActivateFirstSuggest={true}
          initialValue={input.value}
          onKeyDown={onKeyDown}
          onKeyPress={suggestOnKeyPress}
          onPaste={onPaste}
          skipSuggest={skipSuggest}
          getSuggestLabel={getSuggestLabel}
          renderSuggestItem={renderSuggestItem}
          onSuggestNoResults={handleSuggestNoResult}
          placeDetailFields={["adr_address", "address_component"]}
          {...input}
        />
        <Label>{label}</Label>
      </FormField>
    )
  }
}

export {GeosuggestComponent}
